import React, { createContext, useContext } from 'react';
import { UploadChangeParam } from 'antd/lib/upload';
import { DesignAsset } from './types';

export { ASSET_VERSIONING_EXPERIMENT } from '../../../clients/shared/utils/assetTaskVersion';

type AssetVersioningState = {
  enabled: boolean;
  onUploadChange: (
    event: UploadChangeParam<any>,
    type?: string,
    assetId?: number
  ) => void;
  resyncFigmaAsset: (asset: DesignAsset) => Promise<void>;
};

const AssetVersioningContext = createContext<AssetVersioningState | undefined>(
  undefined
);
const AssetVersioningProvider = AssetVersioningContext.Provider as any;

const useAssetVersioningState = () => useContext(AssetVersioningContext);

export { AssetVersioningProvider, useAssetVersioningState };
